
$(document).ready(function () {
    $('.product__callouts-items').slick({
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: true,
        nextArrow: `
                <button type="button" class="carousel__navigation-button carousel__navigation-button--forward next-slick" data-next="" aria-label="Move to next carousel slide"><span class="icon icon-new icon-arrow-long ">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m17.1 18.9 5.9-6.4L17.1 6m5.9 6.4H0" stroke="currentColor" stroke-width="1.1"></path></svg>
            </span>
            </button>
            `,

        prevArrow: `
                <button type="button" class="carousel__navigation-button carousel__navigation-button--back prev-slick" data-prev="" aria-label="Move to previous carousel slide"><span class="icon icon-new icon-arrow-long ">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="m17.1 18.9 5.9-6.4L17.1 6m5.9 6.4H0" stroke="currentColor" stroke-width="1.1"></path></svg>
            </span>
            </button>
            `,

        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2 } },
            { breakpoint: 768, settings: { slidesToShow: 1 } },
        ],
    });
});
